export const signerDataList = [
  {
    signOwner: "签署方一",
    ischecked: true,
    url: "/images/signature/add-sign_a.png"
  },
  {
    signOwner: "签署方二",
    ischecked: false,
    url: "/images/signature/add-sign_b.png"
  },
  {
    signOwner: "签署方三",
    ischecked: false,
    url: "/images/signature/add-sign_c.png"
  },
  {
    signOwner: "签署方四",
    ischecked: false,
    url: "/images/signature/add-sign_d.png"
  },
  {
    signOwner: "签署方五",
    ischecked: false,
    url: "/images/signature/add-sign_e.png"
  },
  {
    signOwner: "签署方六",
    ischecked: false,
    url: "/images/signature/add-sign_f.png"
  },
  {
    signOwner: "签署方七",
    ischecked: false,
    url: "/images/signature/add-sign_g.png"
  },
  {
    signOwner: "签署方八",
    ischecked: false,
    url: "/images/signature/add-sign_h.png"
  },
  {
    signOwner: "签署方九",
    ischecked: false,
    url: "/images/signature/add-sign_i.png"
  },
  {
    signOwner: "签署方十",
    ischecked: false,
    url: "/images/signature/add-sign_j.png"
  },
  {
    signOwner: "批量签署方",
    ischecked: false,
    url: "/images/signature/add-sign_batch.png"
  }
];


// WEBPACK FOOTER //
// ./pages/initiation/common.js